import { WRiskAssessmentProperties } from './w-risk-assessment-properties';
import { WTextViewMode } from './w-text-view-mode';

export class WProperties {
  private static validObjectKey: string[] = [
    'skipComment',
    'skipNullValue',
    'textViewMode',
    'riskAssessmentViewMode',
    'simpleRadioMaxSize',
    'skipEvalQuestion',
    'skipNote',
    'hasChildren',
    'flatViewMaxSize',
    'flat',
    'group',
    'uniqueRecipient'
  ];

  /*
    Properties ALL
  */
  skipComment?: boolean;

  /*
    Properties  SIMPLE RADIO BUTTON
  */
  skipNullValue?: boolean;

  /*
    Properties TEXT_AREA
  */
  textViewMode?: WTextViewMode;

  /*
    Properties RISK_ASSESSMENT
  */
  riskAssessmentViewMode?: WRiskAssessmentProperties;

  /*
    Properties RADIOBUTTON
  */
  simpleRadioMaxSize?: number;  // default 5

  /*
    Properties MultiQuestion
   */
  skipEvalQuestion?: boolean;
  skipNote?: boolean;

  /*
    Properties CHECKBOX
  */
  hasChildren?: boolean;
  flatViewMaxSize?: number; // Default value 13
  flat?: boolean;
  group?: boolean;

  /*
    Properties RECIPIENT_CHOOSER
  */
  uniqueRecipient?: boolean;

  private constructor() {
    this.skipNullValue = false;
    this.skipComment = false;
    this.textViewMode = WTextViewMode.DIALOG;
    this.riskAssessmentViewMode = undefined;
    this.simpleRadioMaxSize = 5;
    this.skipEvalQuestion = false;
    this.skipNote = false;
    this.hasChildren = false;
    this.flatViewMaxSize = 13;
    this.flat = false;
    this.group = false;
    this.uniqueRecipient = true;
  }

  static defaultValue(): WProperties {
    return new WProperties();
  }

  static create(properties: unknown): WProperties {
    const output = new WProperties();

    if (properties === undefined || properties === null) {
      return output;
    }

    const p = properties as any;
    output.skipComment = p.skipComment ? true : false;
    output.skipNullValue = p.skipNullValue ? true : false;
    output.textViewMode = p.textViewMode ? p.textViewMode : WTextViewMode.DIALOG;  // Dubbio sul valore di default
    output.riskAssessmentViewMode = p.riskAssessmentViewMode ? p.riskAssessmentViewMode : WRiskAssessmentProperties.FILL_FROM_QUERY;
    output.simpleRadioMaxSize = p.simpleRadioMaxSize ? p.simpleRadioMaxSize : 5;
    output.skipEvalQuestion = p.skipEvalQuestion ? p.skipEvalQuestion : false;
    output.skipNote = p.skipNote ? p.skipNote : false;
    output.hasChildren = p.hasChildren ? p.hasChildren : false;
    output.flatViewMaxSize = p.flatViewMaxSize ? p.flatViewMaxSize : 13;
    output.flat = p.flat ? p.flat : false;
    output.group = p.group ? p.group : false;
    output.uniqueRecipient = p.uniqueRecipient !== null && p.uniqueRecipient !== undefined ? p.uniqueRecipient : true;

    WProperties.logPropertyError(p);
    return output;
  }

  private static logPropertyError(properties: unknown) {
    if (properties) {
      const currentObjectKey: string[] = Object.keys(properties);
      const invalidObjectKey: string[] = [];
      currentObjectKey.forEach(key => {
        if (!WProperties.validObjectKey.includes(key)) {
          invalidObjectKey.push(key);
        }
      });
    }
  }
}





